export class RCSSuggestionTypeStats {
  suggestionType: string;
  totalSuggestions: number;
  totalClicks: number;
  interactionPercentage: number;
}
